import React from "react";
import arrowSvg from "../images/backlund_arrow.svg";
import "./Arrow.css";

const Arrow = () => (
  <img className="Arrow" src={arrowSvg} alt="Arrow to the right" />
);

export default Arrow;
